export const buildRoomUrl = (name: string) => `https://greatquestion.daily.co/${name}`;
